import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { FileXIcon } from "@phosphor-icons/react/FileX";

interface PaymentsMakePaymentsFailedDialogProps {
  open: boolean;
  /** Closing the failure notice ends the whole flow — the owner closes both dialogs. */
  onOpenChange: (open: boolean) => void;
  errorMessage: string;
}

/** The payment didn't go through: the specific error when we have one. */
export function PaymentsMakePaymentsFailedDialog({
  open,
  onOpenChange,
  errorMessage,
}: PaymentsMakePaymentsFailedDialogProps) {
  const displayMessage =
    errorMessage !== ""
      ? errorMessage
      : "The payment could not be processed at this time. We recommend trying again or contacting our support team for assistance.";

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      width="narrow"
      footer={
        <Row grow justify="center">
          <Button primary onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </Row>
      }
    >
      <Stack align="center" gap={3}>
        <Icon icon={FileXIcon} weight="fill" size="3xl" color="text-red" />
        <T size="xl" weight="medium" align="center">
          Payment Failed
        </T>
        <T size="base" color="secondary" align="center">
          {displayMessage}
        </T>
      </Stack>
    </Dialog>
  );
}
